export default __webpack_public_path__ + "navigation-examples-offline-regions-thumbnail-960-cf50e9b0364b3285bd02dbecacece2f1.png";